'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { LuArrowLeft } from 'react-icons/lu'
import { Box, BoxProps } from '@chakra-ui/react'
import { useRouter } from 'next/navigation'

export const GoBackLink = ({ ...flexProps }: BoxProps): JSX.Element => {
  const { t } = useTranslation('common')
  const router = useRouter()

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="row"
      color="green.a200"
      fontWeight={600}
      fontSize="sm"
      margin="16px 0 20px 0"
      cursor="pointer"
      onClick={() => router.back()}
      {...flexProps}
    >
      <LuArrowLeft size={24} strokeWidth={1.5} style={{ marginRight: '10px' }} />
      {t('goBack')}
    </Box>
  )
}
